/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import styled from 'styled-components';
import { Button, Popover } from 'antd';
import { ColumnHeightOutlined, ColumnWidthOutlined, SendOutlined } from '@ant-design/icons';
import * as L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-geosearch/assets/css/leaflet.css';
import i18next from "i18next";
import { maxBounds } from "../../../constants/map";
import { propHasValue } from "../../../components/DynamicFormNew/helper";
import { convertDMS } from "../../../helpers/map";

const Styles = styled.div`
	display: flex;
  flex-wrap: wrap;
  gap: 10px;
	width: 100%;
	.view-map {
		padding-left: 0;
		.anticon {
			vertical-align: 0;
			margin-right: 0 !important;
		}
	}
	.ant-popover-inner-content {
		padding: 0;
	}

  .cord-value {
    display: flex;
    gap: 10px;

    label {
      margin-bottom: 0px;
      font-weight: 500;
    }

    .cord {
      flex-wrap: no-wrap;
    }

    svg {
      color: var(--color-primary-70);
    
    }
  }

  button {
    margin-top: -5px;

    svg {
      margin-top: -4px;
    }
  }
`;

export default function Geolocation({
  val: value = {
    latitude: undefined,
    longitude: undefined,
  }
}) {
  const [mapId] = useState(Date.now());
  const [mapClass, setMapClass] = useState(null);
  const [posMarker, setPosMarker] = useState(null);
  const [mapVisible, setMapVisible] = useState(false);
  const [model, setModel] = useState({
    latitude: undefined,
    longitude: undefined,
  });

  const icon = new L.Icon({
    iconUrl: "/assets/images/map/position.png",
    iconSize: [20, 30]
  });
  useEffect(() => {
    if (value && propHasValue(value.latitude) && propHasValue(value.longitude)) {
      setModel(value);
    }
  }, [value])
  useEffect(() => {
    if (propHasValue(model.latitude) && propHasValue(model.longitude) && model.latitude && model.longitude) {
      if (mapClass) {
        const zoom = mapClass.getZoom() ? mapClass.getZoom() : 11;
        if (!posMarker) {
          setPosMarker(L.marker([model.latitude, model.longitude], {
            icon: icon,
          }).addTo(mapClass))
        } else {
          posMarker.setLatLng([model.latitude, model.longitude]);
        }
        mapClass.setView([model.latitude, model.longitude], zoom);
      }
    }
  }, [model]);

  useEffect(() => {
    if (mapVisible) {
      initMap();
    }
  }, [mapVisible])

  const initMap = () => {
    setTimeout(() => {
      if (!mapClass) {
        try {
          const map = L.map(document.getElementById(mapId), {
            maxZoom: 18,
            preferCanvas: true,
            doubleClickZoom: false,
            maxBounds: maxBounds,
          });
          setMapClass(map);
          L.control.scale().addTo(map)
          if (!model || !propHasValue(model.latitude) || !propHasValue(model.longitude) || !model.latitude || !model.longitude) {
            // map.getZoom();
            // map.setView([1.5743, 30.2397], zoom);
          } else {
            const zoom = map.getZoom() ? map.getZoom() : 11;
            map.setView([model.latitude, model.longitude], zoom);
          }
          L.tileLayer(
            'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          ).addTo(map);
          if (!posMarker && model.latitude && model.longitude && propHasValue(model.latitude) && propHasValue(model.longitude)) {
            setPosMarker(L.marker([model.latitude, model.longitude], {
              icon: icon
            }).addTo(map))
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        if (!posMarker && model.latitude && model.longitude && propHasValue(model.latitude) && propHasValue(model.longitude)) {
          setPosMarker(L.marker([model.latitude, model.longitude], {
            icon: icon
          }).addTo(mapClass))
        }
      }
    }, 500)
  }

  const { lat, lng } = useMemo(() => {
    const latVal = convertDMS(value.latitude, value.longitude)[0];
    const lngVal = convertDMS(value.latitude, value.longitude)[1];
    return {
      lat: latVal || 0,
      lng: lngVal || 0,
    };
  }, [value]);

  return <Styles>
    <div className="cord-value">
      <div className="cord">
        <ColumnHeightOutlined />
        <label>{lat}</label>
      </div>
      <div className="cord">
        <ColumnWidthOutlined />
        <label>{lng}</label>
      </div>
    </div>
    <Popover
      content={
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div id={mapId} style={{ width: '500px', height: '450px' }}></div>
        </div>
      }
      placement="topRight"
      trigger="click"
      open={mapVisible}
      onOpenChange={(visible) => setMapVisible(visible)}>
      <Button type="link" className="view-map" icon={<SendOutlined rotate="225" />} onClick={() => {
        setMapVisible(true);
      }}>{i18next.t('View on map')} </Button>
    </Popover>
  </Styles >
}
